import PrintableResume from "../components/printable-resume"
export default PrintableResume
